import { ptBRAccessControlPageTranslation } from './access-control';
import { ptBRMeritocracyPageTranslation } from './meritocracy';
import { ptBRMeritocracyParamatersPageTranslation } from './meritocracy-parameters';

export const ptBRPagesTranslation = {
  ...ptBRMeritocracyPageTranslation,
  ...ptBRMeritocracyParamatersPageTranslation,
  ...ptBRAccessControlPageTranslation,
};
